import * as _ from "lodash";
import * as moment from 'moment';
import styled from "styled-components";
import { Component } from "react";
import { Dispatch, connect } from "react-redux";
import { IApplicationState, RecipientActionCreators, AppActionCreators, IDonorFactSheetDataResponse, } from "@nkr/store/index";
import { Paragraph, TableHeader, TableData, TableDataRight, HlaTableHeader, HlaTableData, textStyle, ContentWrapper } from "./styles";
import RecipientNav from "@nkr/views/recipients/recipient-nav";
import { Panel, FormGroup, ControlLabel, FormControl } from "react-bootstrap";


const RecipientDetailsWrapper = styled.table`
  width: 100%;
  tr {
    height: 30px;
  }

  .rd-label {
    font-weight: 600;
    text-align: right;
    padding-right: 10px;
  }

  .rd-value {
    width: 50px;
  }
`;

const HlaTable = styled.table`
  border: 1px solid #000;
  width: 880px;
  ${textStyle}

  colgroup col {
    width: 100px;
  }
`;

interface IProps {
    recipientId,
    donorId,
    centerId,
}

interface IStateProps {
    groupIsSuper: boolean;
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>;
    hideLoading: () => void;
    getDonorFactSheetData: (recipientId: number, donorId: number, centerId: number) => Promise<IDonorFactSheetDataResponse>;
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IhlaData {
    a1: string;
    a2: string;
    bw1: string;
    bw2: string;
    a1HighRes: string;
    a2HighRes: string;
    bw1HighRes: string;
    bw2HighRes: string;
    b1: string;
    b2: string;
    cw1: string;
    cw2: string;
    b1HighRes: string;
    b2HighRes: string;
    cw1HighRes: string;
    cw2HighRes: string;
    dr1: string;
    dr2: string;
    dq1: string;
    dq2: string;
    dr1HighRes: string;
    dr2HighRes: string;
    dq1HighRes: string;
    dq2HighRes: string;
    dp1: string;
    dp2: string;
    dqa1: string;
    dqa2: string;
    dp1HighRes: string;
    dp2HighRes: string;
    dqa1HighRes: string;
    dqa2HighRes: string;
    hasDr51: boolean;
    hasDr52: boolean;
    hasDr53: boolean;
    dr51HighRes: string;
    dr51HighRes2: string;
    dr52HighRes: string;
    dr52HighRes2: string;
    dr53HighRes: string;
    dr53HighRes2: string;
}


interface IState {
    phiFullName: string;
    fullBloodType: string;
    alias: string;
    address: string;
    dob: string;
    abo: string;
    donorCenter: string,
    recipientCenter: string,
    donorAlias: string,
    recipientAlias: string,
    hlaData: IhlaData;
}

class RecipientDonorFactSheet extends Component<TProps, IState> {
    readonly state: IState = {
        phiFullName: "",
        fullBloodType: "",
        alias: "",
        address: "",
        dob: "",
        abo: "",
        donorCenter: "",
        recipientCenter: "",
        donorAlias: "",
        recipientAlias: "",
        hlaData: {
            a1: "",
            a2: "",
            bw1: "",
            bw2: "",
            a1HighRes: "",
            a2HighRes: "",
            bw1HighRes: "",
            bw2HighRes: "",
            b1: "",
            b2: "",
            cw1: "",
            cw2: "",
            b1HighRes: "",
            b2HighRes: "",
            cw1HighRes: "",
            cw2HighRes: "",
            dr1: "",
            dr2: "",
            dq1: "",
            dq2: "",
            dr1HighRes: "",
            dr2HighRes: "",
            dq1HighRes: "",
            dq2HighRes: "",
            dp1: "",
            dp2: "",
            dqa1: "",
            dqa2: "",
            dp1HighRes: "",
            dp2HighRes: "",
            dqa1HighRes: "",
            dqa2HighRes: "",
            hasDr51: false,
            hasDr52: false,
            hasDr53: false,
            dr51HighRes: "",
            dr51HighRes2: "",
            dr52HighRes: "",
            dr52HighRes2: "",
            dr53HighRes: "",
            dr53HighRes2: "",
        }
    };


    componentDidMount = () => {
        this.getData();
    };

    getData = () => {
        this.props
            .showLoading("Getting Donor Fact Sheet data, one moment please...")
            .then(() => {
                this.props
                    .getDonorFactSheetData(this.props.recipientId, this.props.donorId, this.props.centerId)
                    .then((response) => {
                        if (response.data.success) {
                            let {
                                donorFirstName,
                                donorLastName,
                                address1,
                                address2,
                                dateOfBirth,
                                city,
                                state,
                                postalCode,
                                abo,
                                donorCenter,
                                recipientCenter,
                                donorAlias,
                                recipientAlias,
                                hlaA1Lr,
                                hlaA2Lr,
                                hlaB1Lr,
                                hlaB2Lr,
                                hlaDR1Lr,
                                hlaDR2Lr,
                                hlaBW1Lr,
                                hlaBW2Lr,
                                hlaCW1Lr,
                                hlaCW2Lr,
                                hlaDQ1Lr,
                                hlaDQ2Lr,
                                hlaDP1Lr,
                                hlaDP2Lr,
                                hlaDQA1Lr,
                                hlaDQA2Lr,
                                hlaA1Hr,
                                hlaA2Hr,
                                hlaB1Hr,
                                hlaB2Hr,
                                hlaDR1Hr,
                                hlaDR2Hr,
                                hlaBW1Hr,
                                hlaBW2Hr,
                                hlaCW1Hr,
                                hlaCW2Hr,
                                hlaDQ1Hr,
                                hlaDQ2Hr,
                                hlaDP1Hr,
                                hlaDP2Hr,
                                hlaDQA1Hr,
                                hlaDQA2Hr,
                                hlaDR51Lr,
                                hlaDR52Lr,
                                hlaDR53Lr,
                                hlaDR51Hr,
                                hlaDR52Hr,
                                hlaDR53Hr
                            } = response.data.results;

                            this.setState({
                                phiFullName: donorFirstName + " " + donorLastName,
                                address: `${address1}\n${address2}\n${city}, ${state} ${postalCode}`,
                                dob: moment(dateOfBirth).format('YYYY-MM-DD'),
                                abo: abo,
                                donorCenter,
                                recipientCenter,
                                donorAlias,
                                recipientAlias,
                                hlaData: {
                                    a1: hlaA1Lr.toString(),
                                    a2: hlaA2Lr.toString(),
                                    bw1: hlaBW1Lr.toString(),
                                    bw2: hlaBW2Lr.toString(),
                                    a1HighRes: hlaA1Hr?.toString() ?? "",
                                    a2HighRes: hlaA2Hr?.toString() ?? "",
                                    bw1HighRes: hlaBW1Hr?.toString() ?? "",
                                    bw2HighRes: hlaBW2Hr?.toString() ?? "",

                                    b1: hlaB1Lr.toString(),
                                    b2: hlaB2Lr.toString(),
                                    cw1: hlaCW1Lr.toString(),
                                    cw2: hlaCW2Lr.toString(),
                                    b1HighRes: hlaB1Hr.toString(),
                                    b2HighRes: hlaB2Hr.toString(),
                                    cw1HighRes: hlaCW1Hr.toString(),
                                    cw2HighRes: hlaCW2Hr.toString(),

                                    dr1: hlaDR1Lr.toString(),
                                    dr2: hlaDR2Lr.toString(),
                                    dq1: hlaDQ1Lr.toString(),
                                    dq2: hlaDQ2Lr.toString(),
                                    dr1HighRes: hlaDR1Hr.toString(),
                                    dr2HighRes: hlaDR2Hr.toString(),
                                    dq1HighRes: hlaDQ1Hr.toString(),
                                    dq2HighRes: hlaDQ2Hr.toString(),

                                    dp1: hlaDP1Lr.toString(),
                                    dp2: hlaDP2Lr.toString(),
                                    dqa1: hlaDQA1Lr.toString(),
                                    dqa2: hlaDQA2Lr.toString(),
                                    dp1HighRes: hlaDP1Hr.toString(),
                                    dp2HighRes: hlaDP2Hr.toString(),
                                    dqa1HighRes: hlaDQA1Hr.toString(),
                                    dqa2HighRes: hlaDQA2Hr.toString(),

                                    hasDr51: hlaDR51Lr == "Yes",
                                    hasDr52: hlaDR52Lr == "Yes",
                                    hasDr53: hlaDR53Lr == "Yes",
                                    dr51HighRes: hlaDR51Hr.toString(),
                                    dr52HighRes: hlaDR52Hr.toString(),
                                    dr53HighRes: hlaDR53Hr.toString(),

                                    // if you really need the "2" variants as placeholders
                                    dr51HighRes2: "",
                                    dr52HighRes2: "",
                                    dr53HighRes2: ""
                                }
                            });
                        }

                        this.props.hideLoading();
                    });
            });
    };

    render = () => {
        let { phiFullName, address, dob, donorCenter, donorAlias, recipientCenter, recipientAlias, fullBloodType, hlaData } = this.state;

        return (
            <>
                <div style={{ padding: 10 }}>
                    <RecipientNav
                        activeKey={'DONOR-FACT-SHEET'}
                        isAdmin={false}
                        isNkrLogin={this.props.groupIsSuper}
                        centerId={this.props.centerId}
                        recipientId={this.props.recipientId}
                        donorId={this.props.donorId}
                        recipientAlias={recipientAlias}
                    />

                    {this.state.hlaData != null && (<>
                        <Paragraph>
                            Your lab will be performing a cross match to check the compatibility
                            between {donorCenter} donor {donorAlias} and{" "}
                            {recipientCenter} recipient {recipientAlias}.
                        </Paragraph>

                        <ContentWrapper className="compact-form">
                            {/* Recipient Info */}

                            <Panel style={{ maxWidth: "33%", marginLeft: "0" }}>
                                <Panel.Heading>Donor Details</Panel.Heading>
                                <Panel.Body>
                                    {[
                                        { label: "Donor Name", value: phiFullName },
                                        { label: "Address", value: address },
                                        { label: "DOB", value: dob },
                                        { label: "ABO", value: fullBloodType }
                                    ].map((item, idx) => (
                                        <FormGroup
                                            key={idx}
                                            style={{
                                                display: "flex",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            <ControlLabel
                                                style={{
                                                    width: "120px",
                                                    marginBottom: 0,
                                                    whiteSpace: "nowrap",
                                                    display: "flex",           // make label flex
                                                    alignItems: "center",      // vertically center
                                                    lineHeight: "20px"         // match value height
                                                }}
                                            >
                                                {item.label}
                                            </ControlLabel>
                                            <FormControl.Static
                                                style={{
                                                    flex: 1,
                                                    marginBottom: 0,
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    display: "flex",           // make value flex
                                                    alignItems: "center",      // vertically center
                                                    lineHeight: "20px"         // match label height
                                                }}
                                            >
                                                {item.value}
                                            </FormControl.Static>
                                        </FormGroup>
                                    ))}
                                </Panel.Body>
                            </Panel>

                            {/* HLA Typing */}
                            <Panel style={{ maxWidth: "50%", marginLeft: "0" }}>
                                <Panel.Heading>HLA Typing</Panel.Heading>
                                <Panel.Body>
                                    {/* A1, A2, Bw1, Bw2 */}
                                    <table className="table table-bordered hla-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Antigen A-1</th>
                                                <th>Antigen A-2</th>
                                                <th>Antigen Bw-1</th>
                                                <th>Antigen Bw-2</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Standard</td>
                                                <td>{hlaData.a1}</td>
                                                <td>{hlaData.a2}</td>
                                                <td>{hlaData.bw1}</td>
                                                <td>{hlaData.bw2}</td>
                                            </tr>
                                            <tr>
                                                <td>High Res</td>
                                                <td>{hlaData.a1HighRes}</td>
                                                <td>{hlaData.a2HighRes}</td>
                                                <td>{hlaData.bw1HighRes}</td>
                                                <td>{hlaData.bw2HighRes}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* B1, B2, Cw1, Cw2 */}
                                    <table className="table table-bordered hla-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Antigen B-1</th>
                                                <th>Antigen B-2</th>
                                                <th>Antigen Cw-1</th>
                                                <th>Antigen Cw-2</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Standard</td>
                                                <td>{hlaData.b1}</td>
                                                <td>{hlaData.b2}</td>
                                                <td>{hlaData.cw1}</td>
                                                <td>{hlaData.cw2}</td>
                                            </tr>
                                            <tr>
                                                <td>High Res</td>
                                                <td>{hlaData.b1HighRes}</td>
                                                <td>{hlaData.b2HighRes}</td>
                                                <td>{hlaData.cw1HighRes}</td>
                                                <td>{hlaData.cw2HighRes}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* DR1, DR2, DQb1, DQb2 */}
                                    <table className="table table-bordered hla-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Antigen DR-1</th>
                                                <th>Antigen DR-2</th>
                                                <th>Antigen DQb-1</th>
                                                <th>Antigen DQb-2</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Standard</td>
                                                <td>{hlaData.dr1}</td>
                                                <td>{hlaData.dr2}</td>
                                                <td>{hlaData.dq1}</td>
                                                <td>{hlaData.dq2}</td>
                                            </tr>
                                            <tr>
                                                <td>High Res</td>
                                                <td>{hlaData.dr1HighRes}</td>
                                                <td>{hlaData.dr2HighRes}</td>
                                                <td>{hlaData.dq1HighRes}</td>
                                                <td>{hlaData.dq2HighRes}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* DPb1, DPb2, DQa1, DQa2 */}
                                    <table className="table table-bordered hla-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Antigen DPb-1</th>
                                                <th>Antigen DPb-2</th>
                                                <th>Antigen DQa-1</th>
                                                <th>Antigen DQa-2</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Standard</td>
                                                <td>{hlaData.dp1}</td>
                                                <td>{hlaData.dp2}</td>
                                                <td>{hlaData.dqa1}</td>
                                                <td>{hlaData.dqa2}</td>
                                            </tr>
                                            <tr>
                                                <td>High Res</td>
                                                <td>{hlaData.dp1HighRes}</td>
                                                <td>{hlaData.dp2HighRes}</td>
                                                <td>{hlaData.dqa1HighRes}</td>
                                                <td>{hlaData.dqa2HighRes}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* DR51, DR52, DR53 */}
                                    <table className="table table-bordered hla-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Antigen DR51</th>
                                                <th>Antigen DR52</th>
                                                <th>Antigen DR53</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Standard</td>
                                                <td>{hlaData.hasDr51 ? "Yes" : "No"}</td>
                                                <td>{hlaData.hasDr52 ? "Yes" : "No"}</td>
                                                <td>{hlaData.hasDr53 ? "Yes" : "No"}</td>
                                            </tr>
                                            <tr>
                                                <td>High Res</td>
                                                <td>{`${hlaData.dr51HighRes}/${hlaData.dr51HighRes2}`}</td>
                                                <td>{`${hlaData.dr52HighRes}/${hlaData.dr52HighRes2}`}</td>
                                                <td>{`${hlaData.dr53HighRes}/${hlaData.dr53HighRes2}`}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Panel.Body>
                            </Panel>
                        </ContentWrapper>

                    </>)}
                </div>

            </>
        );
    };
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        groupIsSuper: appState.app.user.group.isSuper,
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<IApplicationState>
): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getDonorFactSheetData: (recipientId, donorId, centerId) => {
            return dispatch(
                RecipientActionCreators.getDonorFactSheetData(recipientId, donorId, centerId)
            );
        },
    };
};

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps
)(RecipientDonorFactSheet);
